module.exports = "/images/home-purchase-search-saved-favorites.png?3b85318b630884d0c5be07b3fcb4c79f";